import { Entity } from "./Entity";

export type EntityRepositoryProps<T extends Entity> = {
  entities: T[];
};

export class EntityRepository<T extends Entity> {
  entities: T[];

  constructor(props: EntityRepositoryProps<T>) {
    Object.assign(this, props);
  }
  add(entity: T) {
    if (this.findById(entity.id)) {
      throw new Error(`entity with id ${entity.id} is already stored`);
    }
    this.entities.push(entity);
  }
  addAll(entities: T[]) {
    entities.forEach((entity) => this.add(entity));
  }
  findById(id: string): T | undefined {
    return this.entities.find((_) => _.id === id);
  }
  getById(id: string) {
    const found = this.findById(id);
    if (!found) {
      throw new Error(`could not find entity with id ${id}`);
    }
    return found;
  }
  remove(id: string) {
    this.entities = this.entities.filter((entity) => entity.id !== id);
  }
  isEmpty(): boolean {
    return !this.entities.length;
  }
  static empty<T extends Entity>(): EntityRepository<T> {
    return new EntityRepository<T>({ entities: [] });
  }
}
